import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCompanyDetails } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useUpdateCompanyDetails({
  onSuccessFn = () => null,
  onErrorFn = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: updateCompanyDetails,
    mutationKey: ['updateCompanyDetails'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
      queryclient.invalidateQueries(['getCompanyDetails']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
